import { _ } from '@ngx-translate/core';

export const SHOW_INTERRUPT_SESSION_TIMER = 10000;

/**
 * Команда, которую отправляем боту, чтобы получить токен
 */
export const GET_TOKEN_COMMAND = '/getToken';

export const TELEGRAM_API_CONFIG = {
  id: 3778814,
  hash: 'b1b62e6645cd09ee4d2447824f7b8550',
  baseUrl: 'https://t.me',
} as const;

export const TELEGRAM_LIMITS = {
  foldersCount: 10,
  groups: {
    name: 255,
    description: 255,
  },
} as const;

export const MUTE_FOR_WEEK = 522872381;

/**
 * Сообщения бота
 */
export const BOT_MESSAGES = {
  notRegistered: 'Если кнопка не видна, выполните команду /start.',
  phoneConfirmed: 'Подтверждение прошло успешно.',
  phoneNotConfirmed: 'К сожалению, номер телефона не зарегистрирован в системе."',
  userNotAdded: 'Ошибка получения токена.',
  registered: 'Для начала работы нажмите кнопку "Меню".',
} as const;

/**
 * Ошибки Telegram
 */
//https://core.telegram.org/methods - ссылка на методы с кодами ошибок
export const TELEGRAM_ERRORS: { [k: string]: string } = {
  PHONE_NUMBER_INVALID: _('components.telegram.constants.telegramErrors.phoneNumberInvalid'),
  PHONE_CODE_INVALID: _('components.telegram.constants.telegramErrors.phoneCodeInvalid'),
  PASSWORD_HASH_INVALID: _('components.telegram.constants.telegramErrors.passwordHashInvalid'),
  PHONE_PASSWORD_FLOOD: _('components.telegram.constants.telegramErrors.phonePasswordFlood'),
  PHONE_NUMBER_BANNED: _('components.telegram.constants.telegramErrors.phoneNumberBanned'),
  BOTS_TOO_MUCH: _('components.telegram.constants.telegramErrors.botsTooMuch'),
  BOT_GROUPS_BLOCKED: _('components.telegram.constants.telegramErrors.botGroupsBlocked'),
  USERS_TOO_MUCH: _('components.telegram.constants.telegramErrors.usersTooMuch'),
  USER_CHANNELS_TOO_MUCH: _('components.telegram.constants.telegramErrors.userChannelsTooMuch'),
  USER_KICKED: _('components.telegram.constants.telegramErrors.userKicked'),
  USER_NOT_MUTUAL_CONTACT: _('components.telegram.constants.telegramErrors.userNotMutualContact'),
  USER_PRIVACY_RESTRICTED: _('components.telegram.constants.telegramErrors.userPrivacyRestricted'),
  INVITE_HASH_EMPTY: _('components.telegram.constants.telegramErrors.inviteHashEmpty'),
  INVITE_HASH_EXPIRED: _('components.telegram.constants.telegramErrors.inviteHashExpired'),
  INVITE_HASH_INVALID: _('components.telegram.constants.telegramErrors.inviteHashInvalid'),
  CHANNELS_TOO_MUCH: _('components.telegram.constants.telegramErrors.channelsTooMuch'),
  USER_ALREADY_PARTICIPANT: _('components.telegram.constants.telegramErrors.userAlreadyParticipant'),
  SCHEDULE_DATE_INVALID: _('components.telegram.constants.telegramErrors.scheduleDateInvalid'),
  WALLPAPER_DIMENSIONS_INVALID: _('components.telegram.constants.telegramErrors.wallpaperDimensionsInvalid'),
  ADMINS_TOO_MUCH: _('components.telegram.constants.telegramErrors.adminsTooMuch'),
  ADMIN_RANK_EMOJI_NOT_ALLOWED: _('components.telegram.constants.telegramErrors.adminRankEmojiNotAllowed'),
  ADMIN_RANK_INVALID: _('components.telegram.constants.telegramErrors.adminRankInvalid'),
  FRESH_CHANGE_ADMINS_FORBIDDEN: _('components.telegram.constants.telegramErrors.freshChangeAdminsForbidden'),
  INPUT_USER_DEACTIVATED: _('components.telegram.constants.telegramErrors.inputUserDeactivated'),
  BOT_PRECHECKOUT_TIMEOUT: _('components.telegram.constants.telegramErrors.botPrecheckoutTimeout'),

  //TODO start: Данные сообщения возвращаются в уведомлении (не обрабатываются)
  CHAT_RESTRICTED: _('components.telegram.constants.telegramErrors.chatRestricted'),
  CHAT_SEND_POLL_FORBIDDEN: _('components.telegram.constants.telegramErrors.chatSendPollForbidden'),
  CHAT_SEND_STICKERS_FORBIDDEN: _('components.telegram.constants.telegramErrors.chatSendStickersForbidden'),
  CHAT_SEND_GIFS_FORBIDDEN: _('components.telegram.constants.telegramErrors.chatSendGifsForbidden'),
  CHAT_SEND_MEDIA_FORBIDDEN: _('components.telegram.constants.telegramErrors.chatSendMediaForbidden'),
  CHAT_LINK_EXISTS: _('components.telegram.constants.telegramErrors.chatLinkExists'),
  SLOWMODE_WAIT_X: _('components.telegram.constants.telegramErrors.slowmodeWaitX'),
  USER_BANNED_IN_CHANNEL: _('components.telegram.constants.telegramErrors.userBannedInChannel'),
  USER_IS_BLOCKED: _('components.telegram.constants.telegramErrors.userIsBlocked'),
  YOU_BLOCKED_USER: _('components.telegram.constants.telegramErrors.youBlockedUser'),
  IMAGE_PROCESS_FAILED: _('components.telegram.constants.telegramErrors.imageProcessFailed'),
  MEDIA_EMPTY: _('components.telegram.constants.telegramErrors.mediaEmpty'),
  MEDIA_INVALID: _('components.telegram.constants.telegramErrors.mediaInvalid'),
  PHOTO_CROP_SIZE_SMALL: _('components.telegram.constants.telegramErrors.photoCropSizeSmall'),
  PHOTO_EXT_INVALID: _('components.telegram.constants.telegramErrors.photoExtInvalid'),
  PHOTO_INVALID_DIMENSIONS: _('components.telegram.constants.telegramErrors.photoInvalidDimensions'),
  PHOTO_SAVE_FILE_INVALID: _('components.telegram.constants.telegramErrors.photoSaveFileInvalid'),
  MESSAGE_DELETE_FORBIDDEN: _('components.telegram.constants.telegramErrors.messageDeleteForbidden'),
  MESSAGE_POLL_CLOSED: _('components.telegram.constants.telegramErrors.messagePollClosed'),
  MESSAGE_EDIT_TIME_EXPIRED: _('components.telegram.constants.telegramErrors.messageEditTimeExpired'),
  PINNED_DIALOGS_TOO_MUCH: _('components.telegram.constants.telegramErrors.pinnedDialogsTooMuch'),
  CHANNEL_PRIVATE: _('components.telegram.constants.telegramErrors.channelPrivate'),
  MEDIA_CAPTION_TOO_LONG: _('components.telegram.constants.telegramErrors.mediaCaptionTooLong'),
  ADDRESS_STREET_LINE1_INVALID: _('components.telegram.constants.telegramErrors.addressStreetLine1Invalid'),
  ADDRESS_STREET_LINE2_INVALID: _('components.telegram.constants.telegramErrors.addressStreetLine2Invalid'),
  ADDRESS_CITY_INVALID: _('components.telegram.constants.telegramErrors.addressCityInvalid'),
  ADDRESS_COUNTRY_INVALID: _('components.telegram.constants.telegramErrors.addressCountryInvalid'),
  ADDRESS_POSTCODE_INVALID: _('components.telegram.constants.telegramErrors.addressPostcodeInvalid'),
  ADDRESS_STATE_INVALID: _('components.telegram.constants.telegramErrors.addressStateInvalid'),
  REQ_INFO_NAME_INVALID: _('components.telegram.constants.telegramErrors.reqInfoNameInvalid'),
  REQ_INFO_PHONE_INVALID: _('components.telegram.constants.telegramErrors.reqInfoPhoneInvalid'),
  REQ_INFO_EMAIL_INVALID: _('components.telegram.constants.telegramErrors.reqInfoEmailInvalid'),
  CHANNEL_INVALID: _('components.telegram.constants.telegramErrors.channelInvalid'),
  LINK_NOT_MODIFIED: _('components.telegram.constants.telegramErrors.linkNotModified'),
  MESSAGE_TOO_LONG: _('components.telegram.constants.telegramErrors.messageTooLong'),
  //TODO end

  // Non-API errors
  SERVICE_WORKER_DISABLED:
    'Service Worker is disabled. Streaming media may not be supported. Try reloading the page without holding &lt;Shift&gt; key',
  MESSAGE_TOO_LONG_PLEASE_REMOVE_CHARACTERS:
    'The provided message is too long. Please remove {EXTRA_CHARS_COUNT} character{PLURAL_S}.',
  FRESH_RESET_AUTHORISATION_FORBIDDEN:
    'You can’t logout other sessions if less than 24 hours have passed since you logged on the current session',
};

/**
 * Интервал проверки статуса основного бота
 */
export const CHECK_MAIN_BOT_STATUS_INTERVAL = 5000;

/**
 * Время окончания ожидания чтения статуса бота
 */
export const CHECK_MAIN_BOT_STATUS_TIMEOUT = (10 * 60 * 1000) / CHECK_MAIN_BOT_STATUS_INTERVAL;

/**
 * Время окончания ожидания токена из бота
 */
export const BOT_TOKEN_SENDING_TIMEOUT = 10 * 1000;
